module.exports = __webpack_public_path__ + "static/F6_image_01-88e11a23d2b29d701a812bccba2fd7de.png";